import { render, staticRenderFns } from "./ParticipantShow.vue?vue&type=template&id=3e23db70&scoped=true"
import script from "./ParticipantShow.vue?vue&type=script&lang=js"
export * from "./ParticipantShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e23db70",
  null
  
)

export default component.exports